<template>
  <NumberFilterCommon
    :title="title"
    :value="value"
    :target="target"
    :key-name="keyName"
    :is-display-only="isDisplayOnly"
    :with-inc-exc="false"
    :with-no-input="false"
    :min="0"
    :format-display-value="formatDisplayValue"
    :from-label="$t('leadFilter.lastCallDuration.minSuffix')"
    :to-label="$t('leadFilter.lastCallDuration.maxSuffix')"
    compact-input
    hide-validation-icon
    :invalid-number-message="$t('leadFilter.lastCallDuration.invalidNumberError')"
    :min-max-order-message="$t('leadFilter.lastCallDuration.minMaxOrderError')"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { TFilterParam, TNumberValue, TPropsCommon } from './NumberFilterCommon.vue';
import NumberFilterCommon from './NumberFilterCommon.vue';

type TProps = TPropsCommon & {
  leadListFilterParams?: { [key: string]: TFilterParam };
};
const props = defineProps<TProps>();

const i18n = useI18n();

const target = computed(() => props.leadListFilterParams[props.keyName]);

// 60秒以上は「M分S秒」表記に変換して表示する
const formatSecondsForDisplay = (value: string): string => {
  const seconds = Number(value);
  if (!Number.isFinite(seconds)) return value;
  if (seconds < 60) return i18n.t('leadFilter.lastCallDuration.seconds', { seconds });
  const minutes = Math.floor(seconds / 60);
  const remainderSeconds = seconds % 60;
  return remainderSeconds === 0
    ? i18n.t('leadFilter.lastCallDuration.minutes', { minutes })
    : i18n.t('leadFilter.lastCallDuration.minutesAndSeconds', { minutes, seconds: remainderSeconds });
};

const isEmptyValue = (value: TNumberValue): boolean => value === 'null';

const formatDisplayValue = (rawMin: TNumberValue, rawMax: TNumberValue): string => {
  const min = isEmptyValue(rawMin) ? null : rawMin;
  const max = isEmptyValue(rawMax) ? null : rawMax;
  if (min != null && max != null) {
    return i18n.t('leadFilter.lastCallDuration.rangeBoth', { min: formatSecondsForDisplay(min), max: formatSecondsForDisplay(max) });
  }
  if (min != null) return i18n.t('leadFilter.lastCallDuration.rangeMinOnly', { min: formatSecondsForDisplay(min) });
  if (max != null) return i18n.t('leadFilter.lastCallDuration.rangeMaxOnly', { max: formatSecondsForDisplay(max) });
  return '';
};
</script>
